<script>
/**
 * ****************************************************************************
 * @description     :   panel Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash-uuid';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of panel component
 */
var AnsPanel = {
    template: template,
    props: {
        label: String,
        labelAfter: String,
        subLabel: String,
        listName: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        panelClass: String,
        value: String | Number,
        modelValue: String | Number,
        default: {
            type: Boolean,
            default: true
        },
        isShow: {
            type: Boolean,
            default: true
        },
        isShowIconDrop: {
            type: Boolean,
            default: true
        },
        isShowIconPanel: {
            type: Boolean,
            default: true
        },
        iconPanel: String,
        isDisabled: Boolean,
        options: Array,
        onChange: Function
    },
    data() {
        return {
            show: this.default,
            id: _.uuid()
        };
    },
    methods: {
        toggle() {
            this.show = !this.show;
        }
    }
};
export default AnsPanel;
</script>
